import {
	Box,
	Card,
	CardContent,
	Chip,
	IconButton,
	Skeleton,
	Tooltip,
	Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { useParams } from 'react-router';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { getEuDdpOrder, getEuDdpOrderIsLoad } from 'redux/reducers/euDdp/selectors';
import { OrderDetailsRow } from './OrderDetailsRow';

export const OrderDetails: FC = () => {
	const params = useParams<{ orderId?: string }>();
	const { orderId } = params;

	const order = useSelector(getEuDdpOrder);
	const orderIsLoading = useSelector(getEuDdpOrderIsLoad);
	const orderDetails = order?.orderDetails;

	const [detalization, setDetalization] = useState(false);
	const handleDetalization = () => {
		setDetalization(!detalization);
	};

	return (
		<div>
			{orderId && !orderIsLoading && !!order && order?.order?.id === +orderId ? (
				<Card sx={{ mb: 2, '&': { borderRadius: '12px' } }}>
					<CardContent>
						<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<Box sx={{ display: 'flex', gap: 1, flexDirection: 'row' }}>
								<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
									Order Details
								</Typography>
								{order?.order.valuesStatus && (
									<Chip
										label={order?.order.valuesStatus}
										size="small"
										sx={{
											p: '0 5px',
											ml: 1,
											fontSize: '.7rem',
											height: '20px',
											bgcolor: 'primary.light',
											color: '#000000a5',
										}}
									/>
								)}
							</Box>
							{detalization ? (
								<Tooltip title="Hide more details">
									<IconButton size="small" color="primary" onClick={handleDetalization}>
										<IndeterminateCheckBoxIcon />
									</IconButton>
								</Tooltip>
							) : (
								<Tooltip title="Show more details">
									<IconButton size="small" color="primary" onClick={handleDetalization}>
										<AddBoxIcon />
									</IconButton>
								</Tooltip>
							)}
						</Box>

						<Typography variant="h6" component="div">
							{orderDetails?.rows?.map((item, index) => (
								<OrderDetailsRow
									key={item?.description ?? index}
									orderDetailsRow={item}
									paymentCurrency={order?.order.paymentCurrency}
									detalization={detalization}
								/>
							))}
						</Typography>
						{(orderDetails?.rows?.length ?? 0) > 1 && (
							<Box
								sx={{
									mt: 1.5,
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									border: '1px solid #00000020',
									borderRadius: '12px',
									padding: '10px',
								}}
							>
								<Typography variant="h6" sx={{ fontWeight: 'bold' }} color="primary">
									Total Amount:
								</Typography>
								<AmountAndCurrency
									amount={order?.order.totalOrderValue ?? 0}
									currency={order?.order.paymentCurrency}
									bold
									size={1.3}
									color="primary"
								/>
							</Box>
						)}
					</CardContent>
				</Card>
			) : (
				<Skeleton variant="rectangular" height="200px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
